import getApiInstance from "../../common/api";
import { getUid } from "../../auth/AuthManager";

/** 구독 내역이 아예 없을 때 서버가 돌려주는 코드. 오류가 아니다. */
const errorCodeNoSubscriptionHistory = "10000";

/**
 * 확장팩 부스트 구독 여부. 결제는 모바일 앱에서만 이루어지고
 * 웹은 구독 상태만 조회한다.
 */
export async function fetchIsSubscriber(): Promise<boolean> {
  const uid = await getUid();

  const response = await getApiInstance(undefined).get(
    `/user/getUserSubscribeStatus.php?uid=${uid}`
  );

  const error = response.data.error;
  if (error !== undefined) {
    if (error === errorCodeNoSubscriptionHistory) {
      return false;
    }
    return Promise.reject(error);
  }

  return response.data.result?.is_active === true;
}
